<div
  class="signature-input pos-rel mt-2"
  [ngClass]="{ readonly: readonly }"
  (click)="openSignaturePad()"
  >
  @if (value && !readonly) {
    <div
      class="delete-icon"
      (click)="clearSignature(); $event.stopPropagation()"
      >
      <i class="fa-regular fa-xmark text-danger"></i>
    </div>
  }
  @if (value) {
    <div
      class="signature-image"
      [ngStyle]="{
        backgroundImage: 'url(' + ((value | localImage | async) || 'none') + ')'
      }"
    ></div>
  }
  <small class="text-xs color-light">{{
    '#UI_CORE.COMPONENTS.SIGNATURE_INPUT.INFO' | translate
  }}</small>
</div>
